<template>
  <ul class="keyrow"
      :class="[ {'funcrow': (isfunc === true)}, ('rowsof-' + rowcount) ]">
    <li v-for="(key, index) in keys" :key="index"
        :class="('keysof-' + keycount)">
      <button
          tag="button"
          class="keyboard-button key r-border txt-key"
          :class="[ ('keycodeof-' + key.keyCode), {'disabled': (!key.enabled)}]"
          :disabled="(!key.enabled)"
          @click="onButtonClick({event: $event, entity: key})">{{ key.text | deleteTextFilter }}
      </button>
    </li>
  </ul>
</template>

<script>

// 定义键盘组件的键位行的逻辑
// Author: 陈哈哈 yoojiachen@gmail.com

export default {
  name: "KeyRowView",
  props: ["rowcount", "keys", "isfunc", "keycount"],
  filters: {
    deleteTextFilter: function (text) {
      // if (!text || "←" === text) {
      if (!text ) {
        return "";
      } else {
        return text;
      }
    }
  },
  methods: {
    onButtonClick: function (params) {
      var key = params.entity;
      if (key.enabled) {
        this.$emit("onkeyclick", key);
        this.$emit("onkeyevent", params.event, key);
      }
    }
  }
}
</script>

<style scoped>
ul.keyrow {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  list-style: none;
}

/*上下之间每行间隔*/
ul.keyrow:not(:first-child) {
  margin-top: 8px;
}

ul.rowsof-5 {
  height: -webkit-calc((100% - 8px * 4) / 5);
  height: calc((100% - 8px * 4) / 5);
}

ul.rowsof-4 {
  height: -webkit-calc((100% - 8px * 3) / 4);
  height: calc((100% - 8px * 3) / 4);
}

/*需要设置button在所有父节点上的百分比*/
ul.keyrow > li {
  height: 100%;
}

/*按键左右间隔为5像素*/
ul.keyrow > li:not(:last-child) {
  margin-right: 10px;
}

/*动态计算每个按键的宽度, 按每行10个按键来计算*/
ul.keyrow > li.keysof-10 {
  -webkit-box-flex: 0.095;
  -webkit-flex: 0 1 -webkit-calc((100% - 5px * 9) / 10);
  flex: 0 1 calc((100% - 5px * 9) / 10);
}


/* 增加9键样式 */
/*动态计算每个按键的宽度, 按每行9个按键来计算*/
ul.keyrow > li.keysof-9 {
  -webkit-box-flex: 0.12;
  -webkit-flex: 0 1 -webkit-calc((100% - 5px * 8) / 8);
  flex: 0 1 calc((100% - 5px * 8) / 9);
}

/* 增加11键样式 */
/*动态计算每个按键的宽度, 按每行9个按键来计算*/
ul.keyrow > li.keysof-11 {
  -webkit-box-flex: 0.9;
  -webkit-flex: 0 1 -webkit-calc((100% - 5px * 10) / 11);
  flex: 0 1 calc((100% - 5px * 10) / 11);
}

</style>
